<!--组件说明-->
<!--传入值格式-->
<!--Data="{'obj':'depart','data':departmentList,'attr':{'id':'id','children':'children','label':'label','title':'执行部门'}-->
<!--edit_func:编辑功能回调，delete_func：删除功能回调，drop_func：拖动功能回调-->
<!--obj:对象类型，用来区分写入全局数据-->
<!--data:传入数据列表，必须有主键、名字及子列表字段，可选禁用属性-->
<!--attr:id映射主键，children映射子列表，label映射名字，disabled映射是否禁用，title：选框说明文字,drag:是否可拖动,edit:是否可编辑,delete:是否可删除-->
<template>
    <div class="">
        <span class="col-sm-7">
              <el-tree :data="Data.data" @node-drop='get_node' node-key="id" :props="defaultProps"
                       :draggable="Data.attr.drag===undefined?false:Data.attr.drag" ref="adjustable_tree" class="filter-tree" :render-content="renderContent"
                       :expand-on-click-node="false" :highlight-current="true" default-expand-all :allow-drag="check_node"
              ></el-tree>
         </span>
    </div>
</template>
<script>
export default {
    name: "adjustable_tree",
    props: [
        'Data'
    ],
    data() {
        return {
            defaultProps: {
                id: this.Data.attr.id,
                children: this.Data.attr.children,
                label: this.Data.attr.label,
            },
            edit_flag:this.Data.attr.edit===undefined?false:this.Data.attr.edit,
            delete_flag:this.Data.attr.delete===undefined?false:this.Data.attr.delete,
        }
    },
    mounted() {
    },
    methods: {
        check_node(node){
            return node.data.name !== '智慧管理平台';
        },
        edit(node, data, store) {
            this.$emit(this.Data.attr.edit_func, {'node': node, 'data': data, 'store': store})
        },
        remove(node, data) {
            this.$emit(this.Data.attr.delete_func, {'node': node, 'data': data})
        },
        renderContent(h, {node, data, store}) {
            return (
                <span class="custom-tree-node">
            <span>{node.label}</span>
            <span>
                {this.edit_flag===false?(''):(<el-button size="mini" type="text" on-click={() => this.edit(node, data, store)}>编辑</el-button>)}
                {this.delete_flag===false||node.label==='智慧管理平台'?(''):(<el-button size="mini" type="text" on-click={() => this.remove(node, data)}>删除</el-button>)}
            </span>
          </span>);
        },
        get_node() {
            this.$emit(this.Data.attr.drop_func, this.Data.data)
        },
    }
}
</script>

<style scoped>

</style>
